import React, { useEffect, useState } from "react";
import _ from "lodash";
import { Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { DBCitySearchReturnDetails } from "../Common/Ui/DBCitySearchReturnDetails";
import { toast } from "react-toastify";
import { SendQueryFormComponent } from "../Common/SendQueryFormComponent";
import moment from "moment";
import Joi from "joi";
import { joiResolver } from "@hookform/resolvers/joi";
import { ErrorText } from "../errors/ErrorText";
import { CustomStaticSelect } from "../Common/Ui/CustomStaticSelect";

type FormValues = {
  destination: string;
  Dates: string;
  nights: string;
  CruiseLines?: Date;
};

const cruiseQueryJoi = Joi.object({
  destination: Joi.string().required().label("Destination"),
  Dates: Joi.string().required().label("Dates"),
  nights: Joi.string().required().label("Nights"),
  CruiseLines: Joi.string().required().label("Cruise Lines"),
});

const cruiseLinesOptArr = [
  {
    value: "",
    label: "Select Cruise Line",
  },
  {
    value: "Angriya Cruises",
  },
  {
    value: "Carnival Cruise Line",
  },
  {
    value: "Celebrity Cruises",
  },
  {
    value: "Costa Cruises",
  },
  {
    value: "Cunard Line",
  },
  {
    value: "Disney Cruise Line",
  },
  {
    value: "Dream Cruises",
  },
  {
    value: "Holland America Line",
  },
  {
    value: "MSC Cruises",
  },
  {
    value: "Norwegian Cruise Line",
  },
  {
    value: "Princess Cruises",
  },
  {
    value: "Royal Caribbean International",
  },
];

const CruiseQueryForm: React.FC = (props) => {
  const [showFormSubmissionPopup, setShowFormSubmissionPopup] = useState(false);
  const [monthsState, setMonthsState] = useState<Array<string>>([]);

  useEffect(() => {
    const months: Array<string> = [];
    for (let index = 0; index < 24; index++) {
      months.push(moment().add(index, "months").format("MMM YYYY"));
    }
    setMonthsState(months);
  }, []);

  const onSubmit = (data: FormValues) => {
    // alert(JSON.stringify(data));
    setShowFormSubmissionPopup(true);
  };

  const { handleSubmit, register, watch, formState, getValues, setValue } =
    useForm<FormValues>({
      resolver: joiResolver(cruiseQueryJoi),
      defaultValues: {
        destination: undefined,
        CruiseLines: undefined,
        Dates: undefined,
        nights: undefined,
      },
    });

  const formData = watch();

  const errors = formState.errors;

  return (
    <div className="tab-pane active p-4">
      <div className="row">
        <h3 className="after-heading">Cruise Enquiry</h3>
        <p>Enquire for Domestic / International Cruise. </p>
      </div>
      <div className="row">
        <form>
          <div className="row mb-4">
            <div className="col-lg-3 col-md-6">
              <div className="form-group with-icon">
                <label className=" mb-0">Destination</label>
                <DBCitySearchReturnDetails
                  value={
                    getValues("destination") &&
                    getValues("destination").length > 0
                      ? getValues("destination")
                      : undefined
                  }
                  onChange={(city) => {
                    if (city) {
                      setValue("destination", city.label);
                    } else {
                      setValue("destination", "");
                    }
                  }}
                  error={errors.destination?.message}
                />
                <ErrorText error={errors.destination?.message} />
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="form-group with-icon">
                <CustomStaticSelect
                  id="dates"
                  label="Select Dates"
                  register={register}
                  name="Dates"
                  optionArr={[
                    {
                      value: "",
                      label: "Select Dates",
                    },
                    ...monthsState.map((monthString) => ({
                      value: monthString,
                    })),
                  ]}
                />
                <ErrorText error={errors.Dates?.message} />
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="form-group with-icon">
                <CustomStaticSelect
                  label="Select Nights"
                  id="nights"
                  register={register}
                  name="nights"
                  optionArr={[
                    {
                      value: "",
                      label: "Select Nights",
                    },
                    {
                      value: "1 To 3 night(s)",
                    },
                    {
                      value: "4 To 6 night(s)",
                    },
                    {
                      value: "7 To 9 night(s)",
                    },
                    {
                      value: "10 To 13 night(s)",
                    },
                    {
                      value: "More than 13 night(s)",
                    },
                  ]}
                />
                <ErrorText error={errors.nights?.message} />
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="form-group with-icon">
                <CustomStaticSelect
                  id="cruiseLines"
                  label="Select Cruise Lines"
                  register={register}
                  name="CruiseLines"
                  optionArr={cruiseLinesOptArr}
                />
                <ErrorText error={errors.CruiseLines?.message} />
              </div>
            </div>
          </div>

          <button
            type="button"
            onClick={() => {
              // alert("g");
              handleSubmit(onSubmit)();
            }}
            className="btn btn-primary btn-lg btn-rounded search-button"
          >
            Save Enquiry
          </button>
        </form>
        {showFormSubmissionPopup && (
          <SendQueryFormComponent
            subject="Cruise Enquiry"
            onHide={() => {
              setShowFormSubmissionPopup(false);
            }}
            buttonLabel="Send Cruise Enquiry"
            formDetails={formData}
            popupTitle={"Send Cruise Enquiry"}
            setFormDetails={() => {
              setValue("Dates", "");
              setValue("CruiseLines", undefined);
              setValue("destination", "");
              setValue("nights", "");
            }}
          />
        )}
      </div>
    </div>
  );
};
export default CruiseQueryForm;
